import { render } from "./TopicSuggestions.vue?vue&type=template&id=cf05de0e"
import script from "./TopicSuggestions.vue?vue&type=script&lang=js"
export * from "./TopicSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__